// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__txPG+","card-img":"ProductCard_card-img__hRuL7","card-desc":"ProductCard_card-desc__c5cpV"};